function isDarkColor(hex: string | null | undefined): boolean {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec((hex ?? '').trim());
  if (!match) return false;
  const value = match[1].length === 3 ? match[1].split('').map((c) => c + c).join('') : match[1];
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
}

export function soldOutSwatchImage(hex: string | null | undefined): string {
  const line = isDarkColor(hex) ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.6)';
  return `linear-gradient(to top right, transparent calc(50% - 1px), ${line} calc(50% - 1px), ${line} calc(50% + 1px), transparent calc(50% + 1px))`;
}
